export default "__VITE_ASSET__CcKCoZtT__"